// Textes de navigation
export const NAVIGATION_TEXTS = {
  dashboard: 'Tableau de bord',
  users: 'Utilisateurs',
  organizations: 'Organisations',
  sensors: 'Capteurs',
  locations: 'Emplacements',
  alerts: 'Alertes',
  events: 'Événements',
  account: 'Compte',
  documentSearch: 'Recherche de documents'
} as const;